import { Org } from '@csp/csp-common-model';
import { orgV1Mock } from '@csp/dmdp-api-org-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { OrgMapper } from '../../mapper/OrgMapper';

export const createOrgMock = createMockCreator<Org>({
  ...OrgMapper.fromOrgV1(orgV1Mock),
});
